 import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';


const AttendenceModificationModel = ({open,handleClose,dataSet}) => {
  const [rows, setRows] = useState('');
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  const column = [
     
     { 
       field: 'studentId', 
       headerName: 'Campus Id ', 
      minWidth: 100, 
       flex: 0.7, 
       align: 'center', 
       headerAlign: 'center' 
                                                
     },
     { 
       field: 'studentName', 
       headerName: 'Registration No', 
       minWidth: 100, 
       flex: 0.7, 
       align: 'center', 
       headerAlign: 'center' 
     },
     
     { 
       field: 'total_modifications', 
       headerName: 'Student Name', 
       minWidth: 120, 
       flex: 0.8, 
       align: 'center', 
       headerAlign: 'center' 
     },
      { 
       field: 'all_remarks', 
       headerName: 'Parents No', 
       minWidth: 80, 
       flex: 0.8, 
       align: 'center', 
       headerAlign: 'center' 
     },
     { 
       field: 'modification_details', 
       headerName: ' Attendence %', 
       minWidth: 80, 
       flex: 0.8, 
       align: 'center', 
       headerAlign: 'center' 
     },
      
    
   ];


  

  return (
    <div>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '100%' } }}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        
        >
        <DialogTitle style={{background:'#f7f7f7',color:'black',fontWeight: 'bold',fontSize:'30'}}>
        <Typography>Absentees Details</Typography>
        </DialogTitle>
        <DialogContent>
          
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
            <Grid item xs={12} sm={12} md={12} lg={12} lx={12}>
              <Box sx={{ height: 400 }}>
                               <DataGrid
                                 rows={dataSet}
                                 columns={column}
                                //  getRowId={(row) => row.id}
                                 pageSize={8}
                                 rowsPerPageOptions={[8]}
                                 disableSelectionOnClick
                                 sx={{
                                   '& .MuiDataGrid-columnHeaders': {
                                     backgroundColor: theme.palette.grey[100],
                                   }
                                 }}
                               />
                             </Box>
           </Grid>
           
        
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="contained" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      
    </div>
  );
};
export default AttendenceModificationModel;